import React from "react";

const ExtremeTable = ({ data }) => {
  return (
    <table className="table">
      <thead>
        <tr>
          {Object.keys(data[0]).map((header, index) => (
            <th key={index}>{header}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((row, rowIndex) => (
          <tr key={rowIndex}>
            {Object.values(row).map((cell, cellIndex) => {
              //For taking the row with the links
              if (cellIndex === Object.values(row).length - 1) {
                //case where i have multiple links
                if (cell.length > 50) {
                  if (cell.includes("Απόσταση")) {
                    return <td key={cellIndex}>{cell}</td>;
                  } else {
                    let links = cell.split(/\n|;| /);
                    console.log("extreme")
                    return (
                      <td key={cellIndex}>
                        {links.map((obj) => {
                          obj = obj.replace(" ", "")
                          let link2 = "https://" + obj + "\n";
                          return (
                            <div>
                              <a
                                href={link2}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {obj}
                              </a>
                            </div>
                          );
                        })}
                      </td>
                    );
                  }
                } else {
                  return (
                    <td key={cellIndex}>
                      <a href={cell} target="_blank" rel="noopener noreferrer">
                        {cell}
                      </a>
                    </td>
                  );
                }
              } else {
                return <td key={cellIndex}>{cell}</td>;
              }
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ExtremeTable;
